import template from './component.tpl.html';
import './controller';

/**
 * @ngdoc component
 * @name bo.component:bo-meta-list
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="components">
 <file name="index.html">
 <bo-meta-editor meta-value="{}" meta-definition="{}" on-value-change=""></bo-meta-editor>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.components')
    .component('boMetaEditor', {
        bindings: {
            metaValue: '=',
            metaDefinition: '<',
            onValueChange: '&'
        },
        controller: 'BoMetaEditorController',
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/bo/components/meta-editor/component.js